
import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import changeAirport from '../../js/airport/changeAirport';
import SelectDropdown from '@/components/SelectDropdown.vue';

// 声明变量
// declare const a: any;

@Component({
    components: {
        SelectDropdown,
    },
    filters: {
        Date_MD(data: any) {
            return moment(data).format('MM-DD');
        },
        WeekDay(data: any) {
            moment.locale('zh-cn');
            return moment(data).format('dddd');
        },
        City(data: any) {
            return changeAirport.changeAirportCode(data).cityCName || '无';
        },
        AirPort(data: string) {
            return changeAirport.changeAirportCode(data).airportCName || '无';
        },
        AirLine(data: string) {
            return changeAirport.changeAirCompany(data) || '无';
        },
        ServiceLevel(data: string) {
            if (data === 'F') {
                return '头等舱';
            } else if (data === 'C') {
                return '商务舱';
            } else if (data === 'Y') {
                return '经济舱';
            }

        },
        DisCount(data: number) {
            return (data * 10).toFixed(1);
        },
    },
})
export default class InfoPersonal extends Vue {
    private $api: any;
    private isLoading: boolean = false;
    private showRulesPopup: boolean = false; // 是否展示退改签政策弹出层
    private vm: any = {}; // 获取的订票信息
    private Reasons: any = []; // 退改签原因数据源
    private reason: any = ''; // 选择的原因
    private Remark: any = ''; // 备注
    private trip: any = {}; // 列表页获取的行程信息
    private startEndPlace: any = ''; // 出发地-目的地
    private OrderNo: any = ''; // 订单号
    private refundRules: any = ''; // 退票政策
    private businessTripInfos: any = { // 关联出差信息
        BeginAt: '无',
        EndAt: '无',
        EndPlace: '无',
        Reason: '无',
    };

    private async mounted() {
        this.trip = JSON.parse(localStorage.getItem('tripInfo') || '');
        // 根据ID获取机票信息
        this.getTripInfo();
        // 获取退改签数据源
        this.getReasonSource();
        // 获取退票规定
        this.getRefundRules();
        // 获取关联出差
        this.getBusinessTripInfo();
    }

    // 获取机票信息
    private async getTripInfo() {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        const model = {
            id: this.trip.Id,
        };
        const result = await this.$api.httpGet('basic/Ticket/QueryTicketInfoById', model);
        if (result.Success) {
            if (result.Data) {
                this.OrderNo = result.Data.OrderNo; // 订单号
                // 机票信息
                if (result.Data.NewTicket) {
                    this.vm = result.Data.NewTicket;
                    this.startEndPlace = (changeAirport.changeAirportCode(this.vm.depart) ? changeAirport.changeAirportCode(this.vm.depart).cityCName : '无') + ' — ' + changeAirport.changeAirportCode(this.vm.arrive).cityCName;
                }
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 获取退改签原因数据源
    private async getReasonSource() {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });

        const model = {
            UserTicketId: this.trip.Id,
            Type: 1,
            ChangeDate: null,
        };

        const result = await this.$api.httpPost('Membership/TripInfo/GetReturnDataSourceOfReason', model);
        if (result.Success) {
            if (result.Data) {
                this.Reasons = result.Data.map((item: any) => {
                    return { id: item.Id, text: item.Value };
                });
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 获取退票规定
    private async getRefundRules() {
        const model = {
            id: this.trip.Id,
        };
        const result = await this.$api.httpGet('basic/Ticket/TicketRefundPolicy', model);
        if (result.Success) {
            if (result.Data) {
                this.refundRules = result.Data.refundTicketDes;
            }
        }
    }

    // 获取出差信息
    private async getBusinessTripInfo() {
        const model = {
            BusinessTripInfoId: this.trip.BusinessTripInfoId || '',
        };
        const result = await this.$api.httpGet('Membership/TripInfo/GetBusinessTripInfoById', model);
        if (result.Success) {
            if (result.Data) {
                this.businessTripInfos = result.Data;
                this.businessTripInfos.BeginAt = moment(this.businessTripInfos.BeginAt).format('YYYY-MM-DD HH:MM') || '无';
                this.businessTripInfos.EndAt = moment(this.businessTripInfos.EndAt).format('YYYY-MM-DD HH:MM') || '无';
                this.businessTripInfos.EndPlace = this.businessTripInfos.EndPlace || '无';
                this.businessTripInfos.Reason = this.businessTripInfos.Reason || '无';
            }
        }
    }

    // 退票详情分行
    private getLine(str: string) {
        if (str) {
            str = str.replace(/&#40;/g, '(');
            str = str.replace(/&#41;/g, ')');
            let newStr = '';
            let rows: any = str.split(';');
            for (const i of rows) {
                newStr += `<br/>${i}`;
            }
            return newStr;
        } else {
            return '未查到相关退改签政策信息。';
        }
    }

    // 保存
    private async save() {
        this.$toast.loading({
            mask: true,
            message: '提交中...',
            duration: 0,
        });
        const model = {
            Id: this.trip.Id,
            ReasonTypeId: this.reason.id,
            ReasonTypeValue: this.reason.value,
            Reason: this.Remark,
        };
        const result = await this.$api.httpPost('basic/Ticket/RefundAirTicket', model);
        if (result.Success) {
            this.$toast.clear();
            this.isLoading = true;
            this.$store.commit('showAirTicketResult');
            this.$router.push('/airticket-auditSuccess');
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 取消
    private cancel(str: string) {
        this.$router.push('/tripinfo-list');
    }
}
